/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import { Radio, RadioGroup } from '@mui/material';
import {
  Merchandise,
  SplitLine,
  Tag,
  ItemList, WrongInfo,
} from '@components';
import { ShipmentStatus } from '@constants';
import { useNavigate } from 'react-router-dom';
import { RemarkPanel } from '@/components/choose/remark-panel';
import classes from '../choose/index.module.css';

const HAS_CLAIME_TEXT = 'This item already has a reported issue.';

export const PackageRadioGroup = ({
  packageList, onChange, delayPackageId, onClickTitle,
}) => {
  const navigate = useNavigate();

  const handleItemClick = (item) => {
    navigate(`/17track/feedback?claimId=${item.claimId}`);
  };

  return (
    <RadioGroup>
      {packageList.map((packageItem, packageIndex) => (
        <div key={packageItem.fulfillmentId}>
          {packageIndex === 0 ? null : <SplitLine />}
          <section className={classes.radio_line}>
            <Radio
              color="input"
              onChange={onChange}
              value={packageItem.fulfillmentId}
              style={{
                padding: '0PX',
                marginRight: '8PX',
              }}
              checked={packageItem.fulfillmentId === delayPackageId}
              disabled={!!packageItem?.items[0]?.claimId}
            />
            <span onClick={() => onClickTitle(packageItem)} className={classes.order_name}>
              <span className={classes.order_name_title}>Order</span>
              {`${packageItem.fulfillmentName}`}
            </span>
            <Tag
              color={packageItem.status === ShipmentStatus.Delivered ? '#AEE9D1' : '#E4E5E7'}
              text={packageItem.status === ShipmentStatus.Delivered ? 'Delivered' : 'Undelivered'}
            />
            {
              !(packageItem.status === ShipmentStatus.Delivered) ? (
                <WrongInfo name={packageItem.fulfillmentName} status={packageItem.status} />
              ) : null
            }
          </section>
          {packageItem.items.map(((item, index) => (
            <ItemList
              key={`${item.lineItemId}_${index}`}
              item={item}
              itemKey={`${item.lineItemId}_${index}`}
              index={index}
            >
              <div>
                <Merchandise item={item}>
                  {item.claimId
                    ? (
                      <RemarkPanel
                        title={HAS_CLAIME_TEXT}
                        btnText="View issue &gt; "
                        isShow={false}
                        onClick={() => handleItemClick(item)}
                      />
                    )

                    : null}
                </Merchandise>
              </div>
            </ItemList>
          )))}
        </div>
      ))}
    </RadioGroup>
  );
};
